var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"colorpicker"},[_c('ColorPicker',_vm._b({attrs:{"color-format":"hex"},on:{"change":_vm.update}},'ColorPicker',{value: _vm.value},false))],1)}
var staticRenderFns = []

export { render, staticRenderFns }